export default __webpack_public_path__ + "static/media/document-upload-success-light.9ea0929c.png";